'use strict';

define('modules/module-bundle.std',[
  './module-registry',
  './module.blank',
  './module.fad',
  './module.kbb',
  './module.compare.generic',
  './module.compare.specific',
  './module.offer.generic',
  './module.offer.specific',
  './module.camry.static',
  './module.inventory.generic',
  './module.inventory.specific',
  './module.slp.contact',
  './module.vehicleInfo.specific',
  './module.favorites',
  './module.fad.static',
  './module.static',
  './module.dealers'], function (
  ModuleRegistry,
  BlankModule,
  FadModule,
  KBBModule,
  CompareGenericModule,
  CompareSpecificModule,
  OfferGenericModule,
  OfferSpecificModule,
  CamryStaticModule,
  InventoryGenericModule,
  InventorySpecificModule,
  SlpContactModule,
  VehicleInfoSpecificModule,
  FavoritesModule,
  FadStaticModule,
  StaticModule,
  DealersModule
) {
  // Register the loaded modules
  ModuleRegistry.registerModule('blank', BlankModule);
  ModuleRegistry.registerModule('static', StaticModule);
  ModuleRegistry.registerModule('dealers', DealersModule);

  // TODO: Vehicle Info : vehicleInfo
  ModuleRegistry.registerModule('slp.contact', SlpContactModule);
  ModuleRegistry.registerModule('vehicleInfo.specific', VehicleInfoSpecificModule);
  ModuleRegistry.registerModule('favorites', FavoritesModule);
  ModuleRegistry.registerModule('offer.generic', OfferGenericModule);
  ModuleRegistry.registerModule('offer.specific', OfferSpecificModule);
  ModuleRegistry.registerModule('inventory.generic', InventoryGenericModule);
  ModuleRegistry.registerModule('inventory.specific', InventorySpecificModule);
  ModuleRegistry.registerModule('compare.generic', CompareGenericModule);
  ModuleRegistry.registerModule('compare.specific', CompareSpecificModule);
  ModuleRegistry.registerModule('kbb', KBBModule);
  ModuleRegistry.registerModule('custom', StaticModule);
  ModuleRegistry.registerModule('fad', FadModule);

  ModuleRegistry.registerModule('camryStatic', CamryStaticModule);
  ModuleRegistry.registerModule('fadStatic', FadStaticModule);

  // Return them just in case.
  return {
    BlankModule: BlankModule,
    FadModule: FadModule,
    KBBModule: KBBModule,
    CompareGenericModule: CompareGenericModule,
    CompareSpecificModule: CompareSpecificModule,
    OfferGenericModule: OfferGenericModule,
    OfferSpecificModule: OfferSpecificModule,
    CamryStaticModule: CamryStaticModule,
    InventoryGenericModule: InventoryGenericModule,
    InventorySpecificModule: InventorySpecificModule,
    SlpContactModule: SlpContactModule,
    VehicleInfoSpecificModule: VehicleInfoSpecificModule,
    FavoritesModule: FavoritesModule,
    FadStaticModule: FadStaticModule,
    StaticModule: StaticModule,
    DealersModule: DealersModule,
  };
});

